import { render, staticRenderFns } from "./priceMad.vue?vue&type=template&id=23190898&"
import script from "./priceMad.vue?vue&type=script&lang=js&"
export * from "./priceMad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports